import { parseSanitizedHtml } from "@/utils/sanitizeHtml";
import type { ReactNode } from "react";
import Modal from "@modalSrc/Modal";

type ContentViewModalProps = {
    isOpen: boolean;
    onClose: () => void;
    content?: string | ReactNode;
    title?: string;
};

export default function ContentViewModal({
    isOpen,
    onClose,
    content,
    title = "Content",
}: ContentViewModalProps) {
    const footer = (
        <div className="footerCenter">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
                Close
            </button>
        </div>
    );

    return (
        <Modal
            isOpen={!!isOpen}
            onClose={onClose}
            title={title}
            footer={footer}
            zIndex={1300}
        >
            <div className="contentViewModalBody">
                {parseSanitizedHtml(typeof content === "string" ? content : "")}
            </div>
        </Modal>
    );
}


